// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-Messages-styles-__messages-in-transit__wrapper--1WOlZ","items":"src-components-Messages-styles-__messages-in-transit__items--8-JLO","ellipsis":"src-components-Messages-styles-__messages-in-transit__ellipsis--8cUtc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Messages/styles/messages-in-transit.css
// module id = 1970
// module chunks = 0